import DisputeQAReport from "./DisputeQAReport.component";

export default DisputeQAReport;
